import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getRegionNames } from '@/metrics/helpers/helpers'

import CountryStatItem from './CountryStatItem/CountryStatItem'
import * as Styles from './styles'

const SizingIssuesCountries = ({ recommendation }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const regionNames = getRegionNames(i18n.language)

  return (
    <Styles.Container>
      <Text type="allCapsM" color={theme.colors.text.muted}>
        {t('Problemas específicos por región')}
      </Text>

      <Styles.StatsList>
        {Object.entries(recommendation).map(([countryCode, data]) => (
          <li key={countryCode}>
            <CountryStatItem countryCode={countryCode} countryName={regionNames.of(countryCode)} data={data} />
          </li>
        ))}
      </Styles.StatsList>
    </Styles.Container>
  )
}

export default SizingIssuesCountries
